import React from "react";
import "../add-applications-modal.scss";
import { Formik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import Loader from "../../../loader/loader";
import SelectDropDown from "../../../shared/drop-down/drop-down";
import Cleave from "cleave.js/react";
import { CreatePrevetApplication, getPreappById } from "../../../../api";
import * as yup from "yup";
import config from "../../../../config";
import { withRouter } from "react-router-dom";

const phoneRegex =
    /^\(?(?:[0-9]{3})\)?[-.\s+]?(?:[0-9]{3})[-.\s+]?(?:[0-9]{4})$/;
const MAIN_URL = config.paymentcloud.MAIN_URL;

const schema = yup.object({
    field_firstname: yup.string().trim().required("* First Name is required"),
    field_lastname: yup.string().trim().required("* Last name is required"),
    field_website: yup.string().trim().required("* URL is required"),
    field_processing: yup.string().trim().required("* Processing is required"),
    volume: yup.string().trim().required("* Volume is required"),
    field_dba: yup.string().trim().required("* DBA name is required"),
    field_email: yup
        .string()
        .email("* Invalid email Address")
        .when("showRequiredField", (fieldRequired, schema) => {
            return fieldRequired === "no"
                ? schema
                : schema.required("* Email is required");
        }),
    field_personalphone: yup
        .string()
        .matches(phoneRegex, "* Input contact number correctly.")
        .when("showRequiredField", (fieldRequired, schema) => {
            return fieldRequired === "no"
                ? schema
                : schema.required("* Contact number is required");
        }),
});

class PrevetFormTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_submitted: false,
            formData: {
                id: "",
                field_firstname: "",
                field_lastname: "",
                field_personalphone: "",
                field_email: "",
                field_dba: "",
                field_website: "",
                field_processing: "",
                note: "",
                volume: "",
            },
            errors: [],
            show_spinner: false,
            errorMessage: "",
            applicationUrl: "",
            successMessage: "",
            disableBtn: false,
        };
    }

    handleAddApplication = (evt) => {
        if (this.state.errorMessage == "") {
            this.setState({ disableBtn: true });
            this.setState({ show_spinner: true });
            const fromData = this.state.formData;
            let fd = new FormData();
            fd.append("field_firstname", fromData.field_firstname);
            fd.append("field_lastname", fromData.field_lastname);
            fd.append("field_personalphone", fromData.field_personalphone);
            fd.append("field_email", fromData.field_email);
            fd.append("field_dba", fromData.field_dba);
            fd.append("field_website", fromData.field_website);
            fd.append("field_processing", fromData.field_processing);
            fd.append("volume", fromData.volume);
            fd.append("submit_type", fromData.submit_type);
            fd.append("note", fromData.note);

            CreatePrevetApplication(fd)
                .then((response) => {
                    this.setState({ show_spinner: false });
                    if (response.status === true) {
                        this.setState({ successMessage: response.message });
                        // After few seconds disappear
                        setTimeout(() => {
                            this.setState({
                                successMessage: "",
                                disableBtn: false,
                            });
                            this.props.handleCloseCreatedAppModel();
                            this.props.getPreappData();
                        }, 4000);
                    } else {
                        this.setState({
                            smtpErrorMessage: response.message,
                            disableBtn: false,
                        });
                    }
                })
                .catch((error) => {
                    this.setState({ show_spinner: false });
                });
        }
    };

    updateSubmitType(event) {
        let formData = this.state.formData;
        formData["submit_type"] = event;
    }
    updateChange(event) {
        const targetName = event.target.name;
        if (targetName === "") {
            return false;
        }
        let formData = this.state.formData;
        formData[targetName] = event.target.value.trim();
        this.setState({ formData: formData, errorMessage: "" });
    }

    render() {
        const {
            successMessage,
            errorMessage,
            show_spinner,
            is_submitted,
            formData,
            errors,
        } = this.state;
        return successMessage ? (
            <div>{successMessage}</div>
        ) : (
            <div>
                <Formik
                    enableReinitialize
                    validationSchema={schema}
                    onSubmit={(e) => this.handleAddApplication(e)}
                    initialValues={formData}
                    initialErrors={errors}
                    validateOnBlur={false}
                    validateOnChange={is_submitted}
                    validate={(values) => {
                        this.setState({ is_submitted: true });
                    }}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values,
                        touched,
                        errors,
                    }) => (
                        <Form
                            id="add-application-form"
                            onSubmit={handleSubmit}
                            onChange={(e) => this.updateChange(e)}
                            autoComplete="off"
                        >
                            <Row>
                                <Form.Group as={Col} md={6} className="px-3">
                                    <Form.Control
                                        placeholder="First Name"
                                        type="text"
                                        name="field_firstname"
                                        value={values.field_firstname}
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.field_firstname &&
                                            !!errors.field_firstname
                                        }
                                        isValid={
                                            is_submitted &&
                                            !errors.field_firstname
                                        }
                                        className="preapp-form-input"
                                    />
                                    <label className="modal-lab">
                                        First Name
                                    </label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {" "}
                                        {errors.field_firstname}{" "}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md={6} className="px-3">
                                    <Form.Control
                                        placeholder="Last Name"
                                        type="text"
                                        name="field_lastname"
                                        value={values.field_lastname}
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.field_lastname &&
                                            !!errors.field_lastname
                                        }
                                        isValid={
                                            is_submitted &&
                                            !errors.field_lastname
                                        }
                                        className="preapp-form-input"
                                    />
                                    <label className="modal-lab">
                                        Last Name
                                    </label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {" "}
                                        {errors.field_lastname}{" "}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>

                            <Row>
                                <Form.Group as={Col} md={6} className="px-3">
                                    <Cleave
                                        options={{
                                            blocks: [3, 3, 4],
                                            delimiter: "-",
                                            numericOnly: true,
                                        }}
                                        placeholder="Contact Number"
                                        name="field_personalphone"
                                        value={values.field_personalphone}
                                        onChange={handleChange}
                                        type="text"
                                        inputMode="numeric"
                                        className={`preapp-form-input form-control ${
                                            is_submitted &&
                                            !errors.field_personalphone &&
                                            "is-valid"
                                        } ${
                                            touched.field_personalphone &&
                                            !!errors.field_personalphone &&
                                            "is-invalid"
                                        }`}
                                    />
                                    <label className="modal-lab">Phone</label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {" "}
                                        {errors.field_personalphone}{" "}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md={6} className="px-3">
                                    <Form.Control
                                        placeholder="Email"
                                        type="email"
                                        name="field_email"
                                        value={values.field_email}
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.field_email &&
                                            !!errors.field_email
                                        }
                                        isValid={
                                            is_submitted && !errors.field_email
                                        }
                                        className="preapp-form-input"
                                    />
                                    <label className="modal-lab">Email</label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {" "}
                                        {errors.field_email}{" "}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>

                            <Row>
                                <Form.Group as={Col} md={6} className="px-3">
                                    <Form.Control
                                        placeholder="DBA"
                                        type="text"
                                        name="field_dba"
                                        value={values.field_dba}
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.field_dba &&
                                            !!errors.field_dba
                                        }
                                        isValid={
                                            is_submitted && !errors.field_dba
                                        }
                                        className="preapp-form-input"
                                    />
                                    <label className="modal-lab">DBA</label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {" "}
                                        {errors.field_dba}{" "}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md={6} className="px-3">
                                    <Form.Control
                                        placeholder="URL"
                                        type="text"
                                        name="field_website"
                                        value={values.field_website}
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.field_website &&
                                            !!errors.field_website
                                        }
                                        isValid={
                                            is_submitted &&
                                            !errors.field_website
                                        }
                                        className="preapp-form-input"
                                    />
                                    <label className="modal-lab">URL</label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {" "}
                                        {errors.field_website}{" "}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>

                            <Row>
                                <Form.Group as={Col} md={6} className="px-3">
                                    <b>Currently Processing</b>
                                    <Form.Check
                                        type="radio"
                                        value={"yes"}
                                        name="field_processing"
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.field_processing &&
                                            !!errors.field_processing
                                        }
                                        isValid={
                                            is_submitted &&
                                            !errors.field_processing
                                        }
                                        label="Yes"
                                    />

                                    <Form.Check
                                        type="radio"
                                        value={"no"}
                                        name="field_processing"
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.field_processing &&
                                            !!errors.field_processing
                                        }
                                        isValid={
                                            is_submitted &&
                                            !errors.field_processing
                                        }
                                        label="No"
                                    />
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {" "}
                                        {errors.field_processing}{" "}
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group as={Col} md={6} className="px-3">
                                    <Form.Control
                                        placeholder="Monthly Volume"
                                        type="text"
                                        name="volume"
                                        value={values.volume}
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.volume && !!errors.volume
                                        }
                                        isValid={is_submitted && !errors.volume}
                                        className="preapp-form-input"
                                    />
                                    <label className="modal-lab">
                                        Monthly Volume
                                    </label>
                                    <Form.Control.Feedback
                                        type="invalid"
                                        className="text-capitalize"
                                    >
                                        {" "}
                                        {errors.volume}{" "}
                                    </Form.Control.Feedback>
                                </Form.Group>
                            </Row>
                            <Row>
                                <Form.Group as={Col} md={6} className="px-3">
                                    <Form.Control
                                        placeholder="Enter Your Note"
                                        type="text"
                                        name="note"
                                        value={values.note}
                                        onChange={handleChange}
                                        isInvalid={
                                            touched.note && !!errors.note
                                        }
                                        isValid={is_submitted && !errors.note}
                                        className="preapp-form-input"
                                    />
                                    <label className="modal-lab">Note:</label>
                                </Form.Group>
                            </Row>
                        </Form>
                    )}
                </Formik>

                {show_spinner ? (
                    <div className="spinner">
                        <Loader />
                    </div>
                ) : (
                    ""
                )}
                <p className="error-message text-center">{errorMessage}</p>
                <div className="modal-footer">
                    <button
                        form="add-application-form"
                        disabled={this.state.disableBtn}
                        type="submit"
                        onClick={() => this.updateSubmitType("Save")}
                        className="btn confirm-button"
                    >
                        {" "}
                        Submit{" "}
                    </button>
                    <button
                        className="btn cancel-button"
                        onClick={() => this.props.handleCloseCreatedAppModel()}
                    >
                        {" "}
                        Cancel{" "}
                    </button>
                </div>
            </div>
        );
    }
}

export default withRouter(PrevetFormTab);
``;
